// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: configd/dashboard.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { DashboardPanelConfig, Panel, PanelType, panelTypeFromJSON, panelTypeToJSON } from "../models/dashboard";
import { Metadata } from "../models/types";

export const protobufPackage = "configd";

/** Dashboard configuration */
export interface Dashboard {
  /** The unique identifier of the dashboard. */
  id: string;
  /** The fabric ID this dashboard belongs to. */
  fabricId: string;
  /** The fabric name this dashboard belongs to. */
  fabricName: string;
  /** The folder ID this dashboard belongs to (required). */
  folderId: string;
  /** The user-defined name of the dashboard. */
  name: string;
  /** The description is a user-defined field to store notes about the dashboard. */
  description: string;
  /** A map of attributes related to the lifecycle of the dashboard. */
  metadata: Metadata | undefined;
}

/** Folder for organizing dashboards (flat structure - no nesting) */
export interface DashboardFolder {
  /** The unique identifier of the folder. */
  id: string;
  /** The fabric ID this folder belongs to. */
  fabricId: string;
  /** The fabric name this folder belongs to. */
  fabricName: string;
  /** The user-defined name of the folder. */
  name: string;
  /** A map of attributes related to the lifecycle of the folder. */
  metadata: Metadata | undefined;
}

/** DashboardPanel configuration */
export interface DashboardPanel {
  /** The unique identifier of the panel. */
  id: string;
  /** The fabric ID this panel belongs to. */
  fabricId: string;
  /** The fabric name this panel belongs to. */
  fabricName: string;
  /** The folder ID this panel belongs to. */
  folderId: string;
  /** The folder name this panel belongs to . */
  folderName: string;
  /** The dashboard ID this panel belongs to. */
  dashboardId: string;
  /** The dashboard name this panel belongs to . */
  dashboardName: string;
  /** The user-defined name of the panel. */
  name: string;
  /** The description is a user-defined field to store notes about the panel. */
  description: string;
  /** The position of the panel in the dashboard. */
  position: number;
  /** The panel type */
  type: PanelType;
  /** The panel config */
  config:
    | DashboardPanelConfig
    | undefined;
  /** A map of attributes related to the lifecycle of the panel. */
  metadata: Metadata | undefined;
}

/** Add one or more dashboards. */
export interface AddDashboardsRequest {
  /** The fabric ID where the dashboards will be created. */
  fabricId: string;
  /** The folder ID where the dashboards will be created. */
  folderId: string;
  /** A list of dashboards to be created. */
  dashboards: Dashboard[];
}

/** Get a specific dashboard by ID. */
export interface GetDashboardRequest {
  /** The fabric ID this dashboard belongs to. */
  fabricId: string;
  /** The folder ID this dashboard belongs to. */
  folderId: string;
  /** The unique identifier of the dashboard. */
  dashboardId: string;
  /** Include object metadata in the response. */
  includeMetadata: boolean;
}

/** Get dashboards in a folder. */
export interface GetDashboardsRequest {
  /** Filter by fabric ID. */
  fabricId: string;
  /** The folder ID to get dashboards from. */
  folderId: string;
  /** The max number of dashboards to return in the response. */
  max: number;
  /** An optional cursor for pagination. */
  cursor: string;
  /** Include object metadata in the response. */
  includeMetadata: boolean;
}

/** Response containing one or more dashboards. */
export interface DashboardsResponse {
  /** A list of dashboards. */
  dashboards: Dashboard[];
  /** The cursor for the next page of results. Empty if no more results. */
  cursor: string;
}

/** Update an existing dashboard. */
export interface UpdateDashboardRequest {
  /** The fabric ID this dashboard belongs to. */
  fabricId: string;
  /** The folder ID this dashboard belongs to. */
  folderId: string;
  /** The unique identifier of the dashboard to update. */
  dashboardId: string;
  /** The updated dashboard. */
  dashboard: Dashboard | undefined;
}

/** Delete a dashboard. */
export interface DeleteDashboardRequest {
  /** The fabric ID this dashboard belongs to. */
  fabricId: string;
  /** The folder ID this dashboard belongs to. */
  folderId: string;
  /** The unique identifier of the dashboard to delete. */
  dashboardId: string;
}

/** Get folders in a fabric. */
export interface GetFoldersRequest {
  /** Filter by fabric ID. */
  fabricId: string;
  /** Include object metadata in the response. */
  includeMetadata: boolean;
}

/** Response for dashboard folders. */
export interface DashboardFoldersResponse {
  /** A list of dashboard folders. */
  folders: DashboardFolder[];
}

/** Add folders. */
export interface AddFoldersRequest {
  /** The fabric ID where the folder will be created. */
  fabricId: string;
  /** A list of folders to be created (only one allowed per fabric). */
  folders: DashboardFolder[];
}

/** Update an existing folder. */
export interface UpdateFolderRequest {
  /** The fabric ID this folder belongs to. */
  fabricId: string;
  /** The unique identifier of the folder to update. */
  folderId: string;
  /** The updated folder. */
  folder: DashboardFolder | undefined;
}

/** Add one or more panels. */
export interface AddPanelsRequest {
  /** The fabric ID where the panel will be created. */
  fabricId: string;
  /** The folder ID where the panel will be created. */
  folderId: string;
  /** The dashboard ID where the panel will be created. */
  dashboardId: string;
  /** A list of dashboards to be created. */
  panels: Panel[];
}

/** Get a specific panel by ID. */
export interface GetPanelRequest {
  /** The fabric ID this panel belongs to. */
  fabricId: string;
  /** The folder ID this panel belongs to. */
  folderId: string;
  /** The dashboard ID this panel belongs to. */
  dashboardId: string;
  /** The unique identifier of the panel. */
  panelId: string;
  /** Include object metadata in the response. */
  includeMetadata: boolean;
}

/** Get panels in a dashboard. */
export interface GetPanelsRequest {
  /** Filter by fabric ID. */
  fabricId: string;
  /** The folder ID to get panels from. */
  folderId: string;
  /** The dashboard ID to get panels from. */
  dashboardId: string;
  /** The max number of panels to return in the response. */
  max: number;
  /** An optional cursor for pagination. */
  cursor: string;
  /** Include object metadata in the response. */
  includeMetadata: boolean;
}

/** Response containing one or more panels. */
export interface DashboardPanels {
  /** A list of dashboards. */
  panels: DashboardPanel[];
  /** The cursor for the next page of results. Empty if no more results. */
  cursor: string;
}

/** Update an existing panel. */
export interface UpdatePanelRequest {
  /** The fabric ID this panel belongs to. */
  fabricId: string;
  /** The folder ID this panel belongs to. */
  folderId: string;
  /** The dashboard ID this panel belongs to. */
  dashboardId: string;
  /** The unique identifier of the panel to update. */
  panelId: string;
  /** The updated panel. */
  panel: Panel | undefined;
}

/** Delete a panel. */
export interface DeletePanelRequest {
  /** The fabric ID this panel belongs to. */
  fabricId: string;
  /** The folder ID this panel belongs to. */
  folderId: string;
  /** The dashboard ID this panel belongs to. */
  dashboardId: string;
  /** The unique identifier of the panel to delete. */
  panelId: string;
}

function createBaseDashboard(): Dashboard {
  return { id: "", fabricId: "", fabricName: "", folderId: "", name: "", description: "", metadata: undefined };
}

export const Dashboard: MessageFns<Dashboard> = {
  encode(message: Dashboard, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    if (message.fabricName !== "") {
      writer.uint32(26).string(message.fabricName);
    }
    if (message.folderId !== "") {
      writer.uint32(34).string(message.folderId);
    }
    if (message.name !== "") {
      writer.uint32(42).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(50).string(message.description);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Dashboard {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDashboard();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fabricName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.folderId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Dashboard {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      fabricName: isSet(object.fabricName) ? globalThis.String(object.fabricName) : "",
      folderId: isSet(object.folderId) ? globalThis.String(object.folderId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
    };
  },

  toJSON(message: Dashboard): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.fabricName !== "") {
      obj.fabricName = message.fabricName;
    }
    if (message.folderId !== "") {
      obj.folderId = message.folderId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Dashboard>, I>>(base?: I): Dashboard {
    return Dashboard.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Dashboard>, I>>(object: I): Dashboard {
    const message = createBaseDashboard();
    message.id = object.id ?? "";
    message.fabricId = object.fabricId ?? "";
    message.fabricName = object.fabricName ?? "";
    message.folderId = object.folderId ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    return message;
  },
};

function createBaseDashboardFolder(): DashboardFolder {
  return { id: "", fabricId: "", fabricName: "", name: "", metadata: undefined };
}

export const DashboardFolder: MessageFns<DashboardFolder> = {
  encode(message: DashboardFolder, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    if (message.fabricName !== "") {
      writer.uint32(26).string(message.fabricName);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DashboardFolder {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDashboardFolder();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fabricName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DashboardFolder {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      fabricName: isSet(object.fabricName) ? globalThis.String(object.fabricName) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
    };
  },

  toJSON(message: DashboardFolder): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.fabricName !== "") {
      obj.fabricName = message.fabricName;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DashboardFolder>, I>>(base?: I): DashboardFolder {
    return DashboardFolder.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DashboardFolder>, I>>(object: I): DashboardFolder {
    const message = createBaseDashboardFolder();
    message.id = object.id ?? "";
    message.fabricId = object.fabricId ?? "";
    message.fabricName = object.fabricName ?? "";
    message.name = object.name ?? "";
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    return message;
  },
};

function createBaseDashboardPanel(): DashboardPanel {
  return {
    id: "",
    fabricId: "",
    fabricName: "",
    folderId: "",
    folderName: "",
    dashboardId: "",
    dashboardName: "",
    name: "",
    description: "",
    position: 0,
    type: 0,
    config: undefined,
    metadata: undefined,
  };
}

export const DashboardPanel: MessageFns<DashboardPanel> = {
  encode(message: DashboardPanel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    if (message.fabricName !== "") {
      writer.uint32(26).string(message.fabricName);
    }
    if (message.folderId !== "") {
      writer.uint32(34).string(message.folderId);
    }
    if (message.folderName !== "") {
      writer.uint32(42).string(message.folderName);
    }
    if (message.dashboardId !== "") {
      writer.uint32(50).string(message.dashboardId);
    }
    if (message.dashboardName !== "") {
      writer.uint32(58).string(message.dashboardName);
    }
    if (message.name !== "") {
      writer.uint32(66).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(74).string(message.description);
    }
    if (message.position !== 0) {
      writer.uint32(80).uint32(message.position);
    }
    if (message.type !== 0) {
      writer.uint32(88).int32(message.type);
    }
    if (message.config !== undefined) {
      DashboardPanelConfig.encode(message.config, writer.uint32(98).fork()).join();
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(106).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DashboardPanel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDashboardPanel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fabricName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.folderId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.folderName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.dashboardId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.dashboardName = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.position = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.config = DashboardPanelConfig.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DashboardPanel {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      fabricName: isSet(object.fabricName) ? globalThis.String(object.fabricName) : "",
      folderId: isSet(object.folderId) ? globalThis.String(object.folderId) : "",
      folderName: isSet(object.folderName) ? globalThis.String(object.folderName) : "",
      dashboardId: isSet(object.dashboardId) ? globalThis.String(object.dashboardId) : "",
      dashboardName: isSet(object.dashboardName) ? globalThis.String(object.dashboardName) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      type: isSet(object.type) ? panelTypeFromJSON(object.type) : 0,
      config: isSet(object.config) ? DashboardPanelConfig.fromJSON(object.config) : undefined,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
    };
  },

  toJSON(message: DashboardPanel): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.fabricName !== "") {
      obj.fabricName = message.fabricName;
    }
    if (message.folderId !== "") {
      obj.folderId = message.folderId;
    }
    if (message.folderName !== "") {
      obj.folderName = message.folderName;
    }
    if (message.dashboardId !== "") {
      obj.dashboardId = message.dashboardId;
    }
    if (message.dashboardName !== "") {
      obj.dashboardName = message.dashboardName;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    if (message.type !== 0) {
      obj.type = panelTypeToJSON(message.type);
    }
    if (message.config !== undefined) {
      obj.config = DashboardPanelConfig.toJSON(message.config);
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DashboardPanel>, I>>(base?: I): DashboardPanel {
    return DashboardPanel.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DashboardPanel>, I>>(object: I): DashboardPanel {
    const message = createBaseDashboardPanel();
    message.id = object.id ?? "";
    message.fabricId = object.fabricId ?? "";
    message.fabricName = object.fabricName ?? "";
    message.folderId = object.folderId ?? "";
    message.folderName = object.folderName ?? "";
    message.dashboardId = object.dashboardId ?? "";
    message.dashboardName = object.dashboardName ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.position = object.position ?? 0;
    message.type = object.type ?? 0;
    message.config = (object.config !== undefined && object.config !== null)
      ? DashboardPanelConfig.fromPartial(object.config)
      : undefined;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    return message;
  },
};

function createBaseAddDashboardsRequest(): AddDashboardsRequest {
  return { fabricId: "", folderId: "", dashboards: [] };
}

export const AddDashboardsRequest: MessageFns<AddDashboardsRequest> = {
  encode(message: AddDashboardsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.folderId !== "") {
      writer.uint32(18).string(message.folderId);
    }
    for (const v of message.dashboards) {
      Dashboard.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddDashboardsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddDashboardsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.folderId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.dashboards.push(Dashboard.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddDashboardsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      folderId: isSet(object.folderId) ? globalThis.String(object.folderId) : "",
      dashboards: globalThis.Array.isArray(object?.dashboards)
        ? object.dashboards.map((e: any) => Dashboard.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AddDashboardsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.folderId !== "") {
      obj.folderId = message.folderId;
    }
    if (message.dashboards?.length) {
      obj.dashboards = message.dashboards.map((e) => Dashboard.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddDashboardsRequest>, I>>(base?: I): AddDashboardsRequest {
    return AddDashboardsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddDashboardsRequest>, I>>(object: I): AddDashboardsRequest {
    const message = createBaseAddDashboardsRequest();
    message.fabricId = object.fabricId ?? "";
    message.folderId = object.folderId ?? "";
    message.dashboards = object.dashboards?.map((e) => Dashboard.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetDashboardRequest(): GetDashboardRequest {
  return { fabricId: "", folderId: "", dashboardId: "", includeMetadata: false };
}

export const GetDashboardRequest: MessageFns<GetDashboardRequest> = {
  encode(message: GetDashboardRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.folderId !== "") {
      writer.uint32(18).string(message.folderId);
    }
    if (message.dashboardId !== "") {
      writer.uint32(26).string(message.dashboardId);
    }
    if (message.includeMetadata !== false) {
      writer.uint32(32).bool(message.includeMetadata);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDashboardRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDashboardRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.folderId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.dashboardId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.includeMetadata = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDashboardRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      folderId: isSet(object.folderId) ? globalThis.String(object.folderId) : "",
      dashboardId: isSet(object.dashboardId) ? globalThis.String(object.dashboardId) : "",
      includeMetadata: isSet(object.includeMetadata) ? globalThis.Boolean(object.includeMetadata) : false,
    };
  },

  toJSON(message: GetDashboardRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.folderId !== "") {
      obj.folderId = message.folderId;
    }
    if (message.dashboardId !== "") {
      obj.dashboardId = message.dashboardId;
    }
    if (message.includeMetadata !== false) {
      obj.includeMetadata = message.includeMetadata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDashboardRequest>, I>>(base?: I): GetDashboardRequest {
    return GetDashboardRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDashboardRequest>, I>>(object: I): GetDashboardRequest {
    const message = createBaseGetDashboardRequest();
    message.fabricId = object.fabricId ?? "";
    message.folderId = object.folderId ?? "";
    message.dashboardId = object.dashboardId ?? "";
    message.includeMetadata = object.includeMetadata ?? false;
    return message;
  },
};

function createBaseGetDashboardsRequest(): GetDashboardsRequest {
  return { fabricId: "", folderId: "", max: 0, cursor: "", includeMetadata: false };
}

export const GetDashboardsRequest: MessageFns<GetDashboardsRequest> = {
  encode(message: GetDashboardsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.folderId !== "") {
      writer.uint32(18).string(message.folderId);
    }
    if (message.max !== 0) {
      writer.uint32(24).uint32(message.max);
    }
    if (message.cursor !== "") {
      writer.uint32(34).string(message.cursor);
    }
    if (message.includeMetadata !== false) {
      writer.uint32(40).bool(message.includeMetadata);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDashboardsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDashboardsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.folderId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.max = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.cursor = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.includeMetadata = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDashboardsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      folderId: isSet(object.folderId) ? globalThis.String(object.folderId) : "",
      max: isSet(object.max) ? globalThis.Number(object.max) : 0,
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : "",
      includeMetadata: isSet(object.includeMetadata) ? globalThis.Boolean(object.includeMetadata) : false,
    };
  },

  toJSON(message: GetDashboardsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.folderId !== "") {
      obj.folderId = message.folderId;
    }
    if (message.max !== 0) {
      obj.max = Math.round(message.max);
    }
    if (message.cursor !== "") {
      obj.cursor = message.cursor;
    }
    if (message.includeMetadata !== false) {
      obj.includeMetadata = message.includeMetadata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDashboardsRequest>, I>>(base?: I): GetDashboardsRequest {
    return GetDashboardsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDashboardsRequest>, I>>(object: I): GetDashboardsRequest {
    const message = createBaseGetDashboardsRequest();
    message.fabricId = object.fabricId ?? "";
    message.folderId = object.folderId ?? "";
    message.max = object.max ?? 0;
    message.cursor = object.cursor ?? "";
    message.includeMetadata = object.includeMetadata ?? false;
    return message;
  },
};

function createBaseDashboardsResponse(): DashboardsResponse {
  return { dashboards: [], cursor: "" };
}

export const DashboardsResponse: MessageFns<DashboardsResponse> = {
  encode(message: DashboardsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.dashboards) {
      Dashboard.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.cursor !== "") {
      writer.uint32(18).string(message.cursor);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DashboardsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDashboardsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dashboards.push(Dashboard.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cursor = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DashboardsResponse {
    return {
      dashboards: globalThis.Array.isArray(object?.dashboards)
        ? object.dashboards.map((e: any) => Dashboard.fromJSON(e))
        : [],
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : "",
    };
  },

  toJSON(message: DashboardsResponse): unknown {
    const obj: any = {};
    if (message.dashboards?.length) {
      obj.dashboards = message.dashboards.map((e) => Dashboard.toJSON(e));
    }
    if (message.cursor !== "") {
      obj.cursor = message.cursor;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DashboardsResponse>, I>>(base?: I): DashboardsResponse {
    return DashboardsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DashboardsResponse>, I>>(object: I): DashboardsResponse {
    const message = createBaseDashboardsResponse();
    message.dashboards = object.dashboards?.map((e) => Dashboard.fromPartial(e)) || [];
    message.cursor = object.cursor ?? "";
    return message;
  },
};

function createBaseUpdateDashboardRequest(): UpdateDashboardRequest {
  return { fabricId: "", folderId: "", dashboardId: "", dashboard: undefined };
}

export const UpdateDashboardRequest: MessageFns<UpdateDashboardRequest> = {
  encode(message: UpdateDashboardRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.folderId !== "") {
      writer.uint32(18).string(message.folderId);
    }
    if (message.dashboardId !== "") {
      writer.uint32(26).string(message.dashboardId);
    }
    if (message.dashboard !== undefined) {
      Dashboard.encode(message.dashboard, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateDashboardRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateDashboardRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.folderId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.dashboardId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.dashboard = Dashboard.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateDashboardRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      folderId: isSet(object.folderId) ? globalThis.String(object.folderId) : "",
      dashboardId: isSet(object.dashboardId) ? globalThis.String(object.dashboardId) : "",
      dashboard: isSet(object.dashboard) ? Dashboard.fromJSON(object.dashboard) : undefined,
    };
  },

  toJSON(message: UpdateDashboardRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.folderId !== "") {
      obj.folderId = message.folderId;
    }
    if (message.dashboardId !== "") {
      obj.dashboardId = message.dashboardId;
    }
    if (message.dashboard !== undefined) {
      obj.dashboard = Dashboard.toJSON(message.dashboard);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateDashboardRequest>, I>>(base?: I): UpdateDashboardRequest {
    return UpdateDashboardRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateDashboardRequest>, I>>(object: I): UpdateDashboardRequest {
    const message = createBaseUpdateDashboardRequest();
    message.fabricId = object.fabricId ?? "";
    message.folderId = object.folderId ?? "";
    message.dashboardId = object.dashboardId ?? "";
    message.dashboard = (object.dashboard !== undefined && object.dashboard !== null)
      ? Dashboard.fromPartial(object.dashboard)
      : undefined;
    return message;
  },
};

function createBaseDeleteDashboardRequest(): DeleteDashboardRequest {
  return { fabricId: "", folderId: "", dashboardId: "" };
}

export const DeleteDashboardRequest: MessageFns<DeleteDashboardRequest> = {
  encode(message: DeleteDashboardRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.folderId !== "") {
      writer.uint32(18).string(message.folderId);
    }
    if (message.dashboardId !== "") {
      writer.uint32(26).string(message.dashboardId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteDashboardRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteDashboardRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.folderId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.dashboardId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteDashboardRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      folderId: isSet(object.folderId) ? globalThis.String(object.folderId) : "",
      dashboardId: isSet(object.dashboardId) ? globalThis.String(object.dashboardId) : "",
    };
  },

  toJSON(message: DeleteDashboardRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.folderId !== "") {
      obj.folderId = message.folderId;
    }
    if (message.dashboardId !== "") {
      obj.dashboardId = message.dashboardId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteDashboardRequest>, I>>(base?: I): DeleteDashboardRequest {
    return DeleteDashboardRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteDashboardRequest>, I>>(object: I): DeleteDashboardRequest {
    const message = createBaseDeleteDashboardRequest();
    message.fabricId = object.fabricId ?? "";
    message.folderId = object.folderId ?? "";
    message.dashboardId = object.dashboardId ?? "";
    return message;
  },
};

function createBaseGetFoldersRequest(): GetFoldersRequest {
  return { fabricId: "", includeMetadata: false };
}

export const GetFoldersRequest: MessageFns<GetFoldersRequest> = {
  encode(message: GetFoldersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.includeMetadata !== false) {
      writer.uint32(16).bool(message.includeMetadata);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFoldersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFoldersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.includeMetadata = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFoldersRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      includeMetadata: isSet(object.includeMetadata) ? globalThis.Boolean(object.includeMetadata) : false,
    };
  },

  toJSON(message: GetFoldersRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.includeMetadata !== false) {
      obj.includeMetadata = message.includeMetadata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFoldersRequest>, I>>(base?: I): GetFoldersRequest {
    return GetFoldersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFoldersRequest>, I>>(object: I): GetFoldersRequest {
    const message = createBaseGetFoldersRequest();
    message.fabricId = object.fabricId ?? "";
    message.includeMetadata = object.includeMetadata ?? false;
    return message;
  },
};

function createBaseDashboardFoldersResponse(): DashboardFoldersResponse {
  return { folders: [] };
}

export const DashboardFoldersResponse: MessageFns<DashboardFoldersResponse> = {
  encode(message: DashboardFoldersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.folders) {
      DashboardFolder.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DashboardFoldersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDashboardFoldersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.folders.push(DashboardFolder.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DashboardFoldersResponse {
    return {
      folders: globalThis.Array.isArray(object?.folders)
        ? object.folders.map((e: any) => DashboardFolder.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DashboardFoldersResponse): unknown {
    const obj: any = {};
    if (message.folders?.length) {
      obj.folders = message.folders.map((e) => DashboardFolder.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DashboardFoldersResponse>, I>>(base?: I): DashboardFoldersResponse {
    return DashboardFoldersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DashboardFoldersResponse>, I>>(object: I): DashboardFoldersResponse {
    const message = createBaseDashboardFoldersResponse();
    message.folders = object.folders?.map((e) => DashboardFolder.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAddFoldersRequest(): AddFoldersRequest {
  return { fabricId: "", folders: [] };
}

export const AddFoldersRequest: MessageFns<AddFoldersRequest> = {
  encode(message: AddFoldersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.folders) {
      DashboardFolder.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddFoldersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddFoldersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.folders.push(DashboardFolder.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddFoldersRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      folders: globalThis.Array.isArray(object?.folders)
        ? object.folders.map((e: any) => DashboardFolder.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AddFoldersRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.folders?.length) {
      obj.folders = message.folders.map((e) => DashboardFolder.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddFoldersRequest>, I>>(base?: I): AddFoldersRequest {
    return AddFoldersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddFoldersRequest>, I>>(object: I): AddFoldersRequest {
    const message = createBaseAddFoldersRequest();
    message.fabricId = object.fabricId ?? "";
    message.folders = object.folders?.map((e) => DashboardFolder.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateFolderRequest(): UpdateFolderRequest {
  return { fabricId: "", folderId: "", folder: undefined };
}

export const UpdateFolderRequest: MessageFns<UpdateFolderRequest> = {
  encode(message: UpdateFolderRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.folderId !== "") {
      writer.uint32(18).string(message.folderId);
    }
    if (message.folder !== undefined) {
      DashboardFolder.encode(message.folder, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateFolderRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateFolderRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.folderId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.folder = DashboardFolder.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateFolderRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      folderId: isSet(object.folderId) ? globalThis.String(object.folderId) : "",
      folder: isSet(object.folder) ? DashboardFolder.fromJSON(object.folder) : undefined,
    };
  },

  toJSON(message: UpdateFolderRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.folderId !== "") {
      obj.folderId = message.folderId;
    }
    if (message.folder !== undefined) {
      obj.folder = DashboardFolder.toJSON(message.folder);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateFolderRequest>, I>>(base?: I): UpdateFolderRequest {
    return UpdateFolderRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateFolderRequest>, I>>(object: I): UpdateFolderRequest {
    const message = createBaseUpdateFolderRequest();
    message.fabricId = object.fabricId ?? "";
    message.folderId = object.folderId ?? "";
    message.folder = (object.folder !== undefined && object.folder !== null)
      ? DashboardFolder.fromPartial(object.folder)
      : undefined;
    return message;
  },
};

function createBaseAddPanelsRequest(): AddPanelsRequest {
  return { fabricId: "", folderId: "", dashboardId: "", panels: [] };
}

export const AddPanelsRequest: MessageFns<AddPanelsRequest> = {
  encode(message: AddPanelsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.folderId !== "") {
      writer.uint32(18).string(message.folderId);
    }
    if (message.dashboardId !== "") {
      writer.uint32(26).string(message.dashboardId);
    }
    for (const v of message.panels) {
      Panel.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddPanelsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddPanelsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.folderId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.dashboardId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.panels.push(Panel.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddPanelsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      folderId: isSet(object.folderId) ? globalThis.String(object.folderId) : "",
      dashboardId: isSet(object.dashboardId) ? globalThis.String(object.dashboardId) : "",
      panels: globalThis.Array.isArray(object?.panels) ? object.panels.map((e: any) => Panel.fromJSON(e)) : [],
    };
  },

  toJSON(message: AddPanelsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.folderId !== "") {
      obj.folderId = message.folderId;
    }
    if (message.dashboardId !== "") {
      obj.dashboardId = message.dashboardId;
    }
    if (message.panels?.length) {
      obj.panels = message.panels.map((e) => Panel.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddPanelsRequest>, I>>(base?: I): AddPanelsRequest {
    return AddPanelsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddPanelsRequest>, I>>(object: I): AddPanelsRequest {
    const message = createBaseAddPanelsRequest();
    message.fabricId = object.fabricId ?? "";
    message.folderId = object.folderId ?? "";
    message.dashboardId = object.dashboardId ?? "";
    message.panels = object.panels?.map((e) => Panel.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetPanelRequest(): GetPanelRequest {
  return { fabricId: "", folderId: "", dashboardId: "", panelId: "", includeMetadata: false };
}

export const GetPanelRequest: MessageFns<GetPanelRequest> = {
  encode(message: GetPanelRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.folderId !== "") {
      writer.uint32(18).string(message.folderId);
    }
    if (message.dashboardId !== "") {
      writer.uint32(26).string(message.dashboardId);
    }
    if (message.panelId !== "") {
      writer.uint32(34).string(message.panelId);
    }
    if (message.includeMetadata !== false) {
      writer.uint32(40).bool(message.includeMetadata);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPanelRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPanelRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.folderId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.dashboardId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.panelId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.includeMetadata = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPanelRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      folderId: isSet(object.folderId) ? globalThis.String(object.folderId) : "",
      dashboardId: isSet(object.dashboardId) ? globalThis.String(object.dashboardId) : "",
      panelId: isSet(object.panelId) ? globalThis.String(object.panelId) : "",
      includeMetadata: isSet(object.includeMetadata) ? globalThis.Boolean(object.includeMetadata) : false,
    };
  },

  toJSON(message: GetPanelRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.folderId !== "") {
      obj.folderId = message.folderId;
    }
    if (message.dashboardId !== "") {
      obj.dashboardId = message.dashboardId;
    }
    if (message.panelId !== "") {
      obj.panelId = message.panelId;
    }
    if (message.includeMetadata !== false) {
      obj.includeMetadata = message.includeMetadata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPanelRequest>, I>>(base?: I): GetPanelRequest {
    return GetPanelRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPanelRequest>, I>>(object: I): GetPanelRequest {
    const message = createBaseGetPanelRequest();
    message.fabricId = object.fabricId ?? "";
    message.folderId = object.folderId ?? "";
    message.dashboardId = object.dashboardId ?? "";
    message.panelId = object.panelId ?? "";
    message.includeMetadata = object.includeMetadata ?? false;
    return message;
  },
};

function createBaseGetPanelsRequest(): GetPanelsRequest {
  return { fabricId: "", folderId: "", dashboardId: "", max: 0, cursor: "", includeMetadata: false };
}

export const GetPanelsRequest: MessageFns<GetPanelsRequest> = {
  encode(message: GetPanelsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.folderId !== "") {
      writer.uint32(18).string(message.folderId);
    }
    if (message.dashboardId !== "") {
      writer.uint32(26).string(message.dashboardId);
    }
    if (message.max !== 0) {
      writer.uint32(32).uint32(message.max);
    }
    if (message.cursor !== "") {
      writer.uint32(42).string(message.cursor);
    }
    if (message.includeMetadata !== false) {
      writer.uint32(48).bool(message.includeMetadata);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPanelsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPanelsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.folderId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.dashboardId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.max = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.cursor = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.includeMetadata = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPanelsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      folderId: isSet(object.folderId) ? globalThis.String(object.folderId) : "",
      dashboardId: isSet(object.dashboardId) ? globalThis.String(object.dashboardId) : "",
      max: isSet(object.max) ? globalThis.Number(object.max) : 0,
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : "",
      includeMetadata: isSet(object.includeMetadata) ? globalThis.Boolean(object.includeMetadata) : false,
    };
  },

  toJSON(message: GetPanelsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.folderId !== "") {
      obj.folderId = message.folderId;
    }
    if (message.dashboardId !== "") {
      obj.dashboardId = message.dashboardId;
    }
    if (message.max !== 0) {
      obj.max = Math.round(message.max);
    }
    if (message.cursor !== "") {
      obj.cursor = message.cursor;
    }
    if (message.includeMetadata !== false) {
      obj.includeMetadata = message.includeMetadata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPanelsRequest>, I>>(base?: I): GetPanelsRequest {
    return GetPanelsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPanelsRequest>, I>>(object: I): GetPanelsRequest {
    const message = createBaseGetPanelsRequest();
    message.fabricId = object.fabricId ?? "";
    message.folderId = object.folderId ?? "";
    message.dashboardId = object.dashboardId ?? "";
    message.max = object.max ?? 0;
    message.cursor = object.cursor ?? "";
    message.includeMetadata = object.includeMetadata ?? false;
    return message;
  },
};

function createBaseDashboardPanels(): DashboardPanels {
  return { panels: [], cursor: "" };
}

export const DashboardPanels: MessageFns<DashboardPanels> = {
  encode(message: DashboardPanels, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.panels) {
      DashboardPanel.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.cursor !== "") {
      writer.uint32(18).string(message.cursor);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DashboardPanels {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDashboardPanels();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.panels.push(DashboardPanel.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cursor = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DashboardPanels {
    return {
      panels: globalThis.Array.isArray(object?.panels) ? object.panels.map((e: any) => DashboardPanel.fromJSON(e)) : [],
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : "",
    };
  },

  toJSON(message: DashboardPanels): unknown {
    const obj: any = {};
    if (message.panels?.length) {
      obj.panels = message.panels.map((e) => DashboardPanel.toJSON(e));
    }
    if (message.cursor !== "") {
      obj.cursor = message.cursor;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DashboardPanels>, I>>(base?: I): DashboardPanels {
    return DashboardPanels.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DashboardPanels>, I>>(object: I): DashboardPanels {
    const message = createBaseDashboardPanels();
    message.panels = object.panels?.map((e) => DashboardPanel.fromPartial(e)) || [];
    message.cursor = object.cursor ?? "";
    return message;
  },
};

function createBaseUpdatePanelRequest(): UpdatePanelRequest {
  return { fabricId: "", folderId: "", dashboardId: "", panelId: "", panel: undefined };
}

export const UpdatePanelRequest: MessageFns<UpdatePanelRequest> = {
  encode(message: UpdatePanelRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.folderId !== "") {
      writer.uint32(18).string(message.folderId);
    }
    if (message.dashboardId !== "") {
      writer.uint32(26).string(message.dashboardId);
    }
    if (message.panelId !== "") {
      writer.uint32(34).string(message.panelId);
    }
    if (message.panel !== undefined) {
      Panel.encode(message.panel, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdatePanelRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdatePanelRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.folderId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.dashboardId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.panelId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.panel = Panel.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdatePanelRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      folderId: isSet(object.folderId) ? globalThis.String(object.folderId) : "",
      dashboardId: isSet(object.dashboardId) ? globalThis.String(object.dashboardId) : "",
      panelId: isSet(object.panelId) ? globalThis.String(object.panelId) : "",
      panel: isSet(object.panel) ? Panel.fromJSON(object.panel) : undefined,
    };
  },

  toJSON(message: UpdatePanelRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.folderId !== "") {
      obj.folderId = message.folderId;
    }
    if (message.dashboardId !== "") {
      obj.dashboardId = message.dashboardId;
    }
    if (message.panelId !== "") {
      obj.panelId = message.panelId;
    }
    if (message.panel !== undefined) {
      obj.panel = Panel.toJSON(message.panel);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdatePanelRequest>, I>>(base?: I): UpdatePanelRequest {
    return UpdatePanelRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdatePanelRequest>, I>>(object: I): UpdatePanelRequest {
    const message = createBaseUpdatePanelRequest();
    message.fabricId = object.fabricId ?? "";
    message.folderId = object.folderId ?? "";
    message.dashboardId = object.dashboardId ?? "";
    message.panelId = object.panelId ?? "";
    message.panel = (object.panel !== undefined && object.panel !== null) ? Panel.fromPartial(object.panel) : undefined;
    return message;
  },
};

function createBaseDeletePanelRequest(): DeletePanelRequest {
  return { fabricId: "", folderId: "", dashboardId: "", panelId: "" };
}

export const DeletePanelRequest: MessageFns<DeletePanelRequest> = {
  encode(message: DeletePanelRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.folderId !== "") {
      writer.uint32(18).string(message.folderId);
    }
    if (message.dashboardId !== "") {
      writer.uint32(26).string(message.dashboardId);
    }
    if (message.panelId !== "") {
      writer.uint32(34).string(message.panelId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeletePanelRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeletePanelRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.folderId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.dashboardId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.panelId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeletePanelRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      folderId: isSet(object.folderId) ? globalThis.String(object.folderId) : "",
      dashboardId: isSet(object.dashboardId) ? globalThis.String(object.dashboardId) : "",
      panelId: isSet(object.panelId) ? globalThis.String(object.panelId) : "",
    };
  },

  toJSON(message: DeletePanelRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.folderId !== "") {
      obj.folderId = message.folderId;
    }
    if (message.dashboardId !== "") {
      obj.dashboardId = message.dashboardId;
    }
    if (message.panelId !== "") {
      obj.panelId = message.panelId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeletePanelRequest>, I>>(base?: I): DeletePanelRequest {
    return DeletePanelRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeletePanelRequest>, I>>(object: I): DeletePanelRequest {
    const message = createBaseDeletePanelRequest();
    message.fabricId = object.fabricId ?? "";
    message.folderId = object.folderId ?? "";
    message.dashboardId = object.dashboardId ?? "";
    message.panelId = object.panelId ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
